import { render } from "./AnimatedCounter.vue?vue&type=template&id=0252422a&scoped=true"
import script from "./AnimatedCounter.vue?vue&type=script&lang=js"
export * from "./AnimatedCounter.vue?vue&type=script&lang=js"

import "./AnimatedCounter.vue?vue&type=style&index=0&id=0252422a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0252422a"]])

export default __exports__